import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const detail = {
  title: '金光护身咒',
  content: [
    '天罗神、地罗神，',
    '天兵天将护我身，',
    '铁人铁马铁将军，',
    '十二护法护我身，',
    '四大护法前面走，',
    '八大金刚护我身，',
    '跟我走来护我身，',
    '一切灾殃化为尘。'
  ],
  description: '此为民间流传之金光护身法咒，诚心念诵可增福慧，化险为夷。',
  usage: [
    '选择吉日吉时焚香诵读',
    '每日早晚各念诵七遍',
    '心诚则灵，需保持善念',
    '不顺时、身体不好时大声念诵'
  ]
};

const FuzouDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-orange-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fuzou')}
            className="flex items-center text-amber-800 mb-8 hover:text-amber-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符咒列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-amber-200 overflow-hidden">
            <div className="bg-gradient-to-r from-amber-500 to-orange-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                {detail.title}
              </h1>
            </div>

            <div className="p-8">
              <p className="text-gray-600 mb-8 italic text-center">
                不顺时，身体不好时，大声的说出来
              </p>

              <div className="space-y-4 text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed font-serif text-center mb-10">
                {detail.content.map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
              </div>

              <div className="space-y-6">
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-100">
                  <h3 className="text-lg font-bold text-amber-900 mb-3">咒语说明</h3>
                  <p className="text-gray-700">{detail.description}</p>
                </div>

                <div className="bg-amber-50 rounded-xl p-6 border border-amber-100">
                  <h3 className="text-lg font-bold text-amber-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {detail.usage.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuzouDetail;
